import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Browser from '@wetransfer/concorde-browser';

import Upsell from './upsell';

import Router from '@module/router';
import I18n from '@module/i18n';

import Actions from '@app/store/action';

import Icon from '@component/icon';

export class Complete extends React.PureComponent {
  state = {
    upsell: false,
  };

  displayUpsell = () => {
    const { user } = this.props;

    if (user.loggedIn) {
      this.newTransfer();
    } else {
      this.setState({ upsell: true });
    }
  };

  newTransfer = () => {
    this.props.createTransfer();
    Router.navigateTo('/');
  };

  getShortcut() {
    const identity = Browser.identity;

    // Get the shortcut to display current downloads in platform/browser
    if (Browser.platform('Win|Windows')) {
      switch (identity.browser) {
        case 'Chrome':
        case 'Firefox':
        case 'Explorer':
          return 'control_j'; // IE 9+

        case 'Safari':
          return 'control_alt_l';
      }
    } else if (Browser.platform('Mac')) {
      switch (identity.browser) {
        case 'Chrome':
          return 'cmd_shift_j';
        case 'Firefox':
          return 'cmd_j';
        case 'Safari':
          return 'cmd_alt_l';
      }
    }

    return null;
  }

  resetDownloadOnEnter = (event) => {
    if (event.key === 'Enter') {
      this.props.resetDownload();
    }
  };

  // Render our view
  render() {
    // const {
    //   transfer: { items },
    // } = this.props;

    const shortcut = this.getShortcut();
    let downloadText = null;

    if (shortcut) {
      downloadText = I18n.t('transfer.downloaded.text', {
        shortcut: I18n.t(`shortcuts.${shortcut}`),
      });
    }

    let actionLabel = I18n.t('transfer.buttons.new_transfer');
    if (Browser.isMobile) {
      actionLabel = I18n.t('transfer.buttons.back_to_home');
    }

    if (this.state.upsell) {
      return <Upsell onContinue={this.newTransfer} />;
    }

    return (
      <div className="transfer__window downloader">
        <div className="transfer__contents">
          <div className="downloader__complete">
            <Icon type="TransferComplete" className="downloader__image" />
            <h2>{I18n.t('transfer.downloaded.title')}</h2>
            {downloadText ? (
              <p dangerouslySetInnerHTML={{ __html: downloadText }} />
            ) : null}
          </div>
        </div>
        <div className="transfer__footer">
          {!Browser.isMobile ? (
            <Icon
              type="TransferBack"
              className="transfer__back"
              onClick={this.props.resetDownload}
              onKeyDown={this.resetDownloadOnEnter}
              label={I18n.t('transfer.buttons.go_to_transfer')}
            />
          ) : null}
          <button className="transfer__button" onClick={this.displayUpsell}>
            {actionLabel}
          </button>
        </div>
      </div>
    );
  }
}

Complete.propTypes = {
  transfer: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
  resetDownload: PropTypes.func.isRequired,
  createTransfer: PropTypes.func.isRequired,
};

const mapStateToProps = ({ user, transfer }) => ({
  user,
  transfer,
});

const mapDispatchToProps = {
  resetDownload: Actions.Transfer.resetDownload,
  createTransfer: Actions.Transfer.create,
};

export default connect(mapStateToProps, mapDispatchToProps)(Complete);
